(function(){
  function initReveal(){
    var els=document.querySelectorAll('.bc-reveal:not(.bc-visible)');
    if(!els.length) return;
    if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      els.forEach(function(e){e.classList.add('bc-visible');}); return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('bc-visible'); io.unobserve(en.target);} });
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){
      var r=e.getBoundingClientRect();
      if(r.top<window.innerHeight){ e.classList.add('bc-visible'); } else { io.observe(e); }
    });
  }
  function initGaleria(){
    document.querySelectorAll('[data-bc-galeria]').forEach(function(g){
      var principal=g.querySelector('[data-bc-principal]');
      g.querySelectorAll('[data-bc-foto]').forEach(function(b){
        b.addEventListener('click',function(){
          principal.src=b.getAttribute('data-bc-foto');
          g.querySelectorAll('[data-bc-foto]').forEach(function(x){x.setAttribute('aria-current','false');});
          b.setAttribute('aria-current','true');
        });
      });
    });
  }
  function initVariantes(){
    document.querySelectorAll('[data-bc-variantes]').forEach(function(sel){
      var cont=sel.closest('[data-bc-producto]');
      sel.addEventListener('change',function(){
        var op=sel.options[sel.selectedIndex];
        var id=cont.querySelector('[data-bc-id]'); if(id) id.value=sel.value;
        cont.querySelectorAll('[data-bc-precio]').forEach(function(p){p.textContent=op.getAttribute('data-precio');});
        var btn=cont.querySelector('[data-bc-anadir]');
        if(btn){ var disp=op.getAttribute('data-disponible')==='true'; btn.disabled=!disp; btn.textContent=disp?btn.getAttribute('data-txt'):btn.getAttribute('data-txt-agotado'); }
      });
    });
  }
  function initBarra(){
    var barra=document.querySelector('[data-bc-barra]'); if(!barra) return;
    var form=document.getElementById(barra.getAttribute('data-bc-form'));
    var btnForm=form?form.querySelector('[data-bc-anadir]'):null;
    barra.querySelector('button').addEventListener('click',function(){ if(btnForm && !btnForm.disabled){ btnForm.click(); } });
    if(!btnForm || !('IntersectionObserver' in window)){ barra.classList.add('bc-barra--on'); return; }
    new IntersectionObserver(function(en){ barra.classList.toggle('bc-barra--on', !en[0].isIntersecting && en[0].boundingClientRect.top<0); }).observe(btnForm);
  }
  function init(){ initReveal(); initGaleria(); initVariantes(); initBarra(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }
  document.addEventListener('shopify:section:load',initReveal);
})();
